import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Menu, Col } from 'antd';

import {comites, isLoginAdmin, logout } from '../utils/JWTAuth';


const { SubMenu } = Menu;
let comites_nav,state_nav;
let comite_vis = 0;
let cerrar_url;

let isAdmin;

isLoginAdmin().then(data => {



  if(data){
    isAdmin = 
    <SubMenu
    key="sub1"
    title={
      <span>
        
        <span>Admin</span>
      </span>
    }
  >
    
      <Menu.Item key="1"><Link to="/admin/titulares">Titulares</Link></Menu.Item>
      <Menu.Item key="2"><Link to="/admin/registro">Registrar</Link></Menu.Item>
   
    
  </SubMenu>;

/*state_nav.setState({
  isAdmin: true,
});*/



  }
});

let updateUrlComite = (id) => {
 
}

class NavBar extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      comites: [],
      comite: 0,
      isAdmin: false,
      cerrar: false,
    }

    state_nav = this

  }

  cerrar() {
    logout();
      

      switch(state_nav.props.comite){
        case '1': cerrar_url = 'comite-nacional-seguridad-vial'; break;
                    case '2': cerrar_url = 'comite-prevencion-y-combate-al-delito'; break;
                    case '3': cerrar_url = 'comite-movilidad'; break;
                    case '4': cerrar_url = 'comite-ferroviario'; break;
                    case '5': cerrar_url = 'comite-juridico'; break;
                    case '6': cerrar_url = 'comite-tecnico'; break;
      }

      

      state_nav.setState({
        cerrar:true
      });

    
};



  handleClick = e => {
    
    
    state_nav.setState({
      comite: e.key
    });

  };

  render() {
    return (

      <Col span={6}>
        <Menu
        onClick={this.handleClick}
        style={{ width: 256 }}
        defaultSelectedKeys={['1']}
        defaultOpenKeys={['sub1']}
        mode="inline"
      >
          {this.props.admin_empresa &&
            (<Menu.Item><Link to={"/representante/"+this.props.comite+"/registro"} >Agregar Suplente</Link></Menu.Item>)
          }
          

          {/*<Menu.Item><Link to={"/representante/"+this.props.comite} >Comité</Link></Menu.Item>*/}

        
        {this.state.cerrar ? 
        (<Menu.Item key="10"><Redirect to={`/login/${cerrar_url}/${state_nav.props.comite}`}></Redirect></Menu.Item>)
        :
        (<Menu.Item key="10" onClick={this.cerrar}>Cerra Sesión</Menu.Item>)
        }

          
        </Menu>
      </Col>

      
    );
  }
}

export default NavBar;